// ThemeProvider.js
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import CreateTheme from "./Theme";
import { useTranslation } from "react-i18next";
import { useMemo, useEffect, useState } from "react";

const getDirection = (lang) => {
  const rtlLangs = ["fa"];
  return rtlLangs.includes(lang) ? "rtl" : "ltr";
};

const createEmotionCache = (direction) =>
  createCache({
    key: direction === "rtl" ? "muirtl" : "mui",
    stylisPlugins: direction === "rtl" ? [prefixer, rtlPlugin] : [],
  });

const ThemeProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(getDirection(i18n.language));

  useEffect(() => {
    const newDir = getDirection(i18n.language);
    setDirection(newDir);
    document.documentElement.setAttribute("dir", newDir);
  }, [i18n.language]);

// ThemeProvider.js
const theme = useMemo(() => CreateTheme(direction, i18n.language), [direction, i18n.language]);
  const cache = useMemo(() => createEmotionCache(direction), [direction]);

  return (
    <CacheProvider value={cache}>
      <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
    </CacheProvider>
  );
};

export default ThemeProvider;
